// ** Reducers Imports
import navbar from "./navbar";
import layout from "./layout";

const rootReducer = {
  navbar,
  layout,
};

export default rootReducer;
